import { diffWords } from 'diff'

type TextDiffProps = {
  oldText: string
  newText: string
  oldTextTitle?: string
  newTextTitle?: string
  /** Hauteur max des zones de texte (ex: "200px", "20rem", "50vh"). Défaut: "300px". */
  maxHeight?: string
}

export const TextDiff = ({
  oldText,
  newText,
  oldTextTitle = '',
  newTextTitle = '',
  maxHeight = '300px',
}: TextDiffProps) => {
  const diffs = diffWords(oldText, newText)
  const scrollStyle = { maxHeight, overflow: 'auto' as const }

  return (
    <div className="grid grid-cols-2 gap-x-[15px] text-gray-1325">
      <div className="font-medium uppercase ml-10px mb-[5px]">
        {oldTextTitle}
      </div>
      <div className="font-medium uppercase ml-10px  mb-[5px]">
        {newTextTitle}
      </div>

      <div
        className="whitespace-pre-wrap border border-gray-1100 dark:border-gray-1350 rounded-15 p-[10px]"
        style={scrollStyle}
      >
        {diffs.map((part, index) => {
          if (part.added) return null
          if (part.removed) {
            return (
              <span key={index} className="bg-green-1000/10 dark:bg-green-1700">
                {part.value}
              </span>
            )
          }
          return <span key={index}>{part.value}</span>
        })}
      </div>

      <div className="whitespace-pre-wrap p-[10px]" style={scrollStyle}>
        {diffs.map((part, index) => {
          if (part.removed) return null
          if (part.added) {
            return (
              <span key={index} className="bg-red-1250/10 dark:bg-red-1950">
                {part.value}
              </span>
            )
          }
          return <span key={index}>{part.value}</span>
        })}
      </div>
    </div>
  )
}
